import { useLazyQuery } from '@apollo/client/react';
import { useMemo } from 'react';

import { GetYakumaruCompanySettingDocument } from '~/graphql/generated/graphql';

export const useGetYakumaruCompanySetting = () => {
  const [getYakumaruCompanySetting, { called, data, error, loading }] = useLazyQuery(
    GetYakumaruCompanySettingDocument,
  );

  const me = data?.me?.__typename === 'Practitioner' ? data.me : null;
  const yakumaruCompanySetting = useMemo(
    () => me?.organization?.company?.yakumaruCompanySetting ?? null,
    [me],
  );
  const companyId = me?.organization?.company?.id ?? null;

  return {
    getYakumaruCompanySetting,
    called,
    error,
    loading,
    yakumaruCompanySetting,
    companyId,
  };
};
